exports = module.exports = require("../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disabled svg{color:grey}.disabled a{cursor:not-allowed}", ""]);

// exports
